export default "<!-- ----- Bill Display ------- -->\r\n<div class=\"bill-display\">\r\n    <div> </div>\r\n</div>";